module.exports = __webpack_public_path__ + "static/media/om.8ced3158.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/om.svg
// module id = 217
// module chunks = 0